var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapGridIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 34,
    viewBox: "0 0 40 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2421 1L12.2947 4.80952L6.8421 2.52381L2.16842 11.6667L6.8421 14.3333L4.11579 20.0476L1.77895 18.9048L1 20.8095L3.33684 21.9524L2.16842 26.9048L6.45263 29.9524L9.56842 25L27.0947 33L27.8737 31.8571L29.8211 33L32.5474 28.4286L36.0526 22.7143L33.7158 21.5714L35.2737 18.9048L34.4947 18.5238L38 11.6667L33.3263 9L32.5474 10.5238L29.4316 9L26.3158 7.47619L25.1474 10.1429L16.5789 6.33333L18.1368 2.90476L14.2421 1Z",
    fill: "#292929",
    stroke: "#292929"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88235 25.84V22.2L3 18.56L4.58824 14.92L10.9412 17.5943M20.4706 25.84L18.3529 30L12 27.4L14.209 22.7505M20.4706 25.84L14.209 22.7505M20.4706 25.84L25.2353 14.92M20.4706 25.84L32.6471 30L36.8824 22.7505L34.7647 21.16L35.8235 18.04M14.209 22.7505L15.7059 19.6L12 18.04L10.9412 17.5943M25.2353 14.92L35.8235 18.04M25.2353 14.92L21.5294 12.84L23.1176 8.68L24.7059 9.2L26.2941 6.6L32.1176 9.72L33.1765 8.68L39 11.8L35.8235 18.04M10.9412 4L8.29412 9.72L13.0588 11.8L10.9412 17.5943",
    stroke: "white",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10536_2686)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10536_2686)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 12C16.1469 12 15.05 13.0969 15.05 14.45C15.05 15.8031 17.5 19 17.5 19C17.5 19 19.95 15.8031 19.95 14.45C19.95 13.0969 18.8531 12 17.5 12Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10536_2686)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 13.3828L16.2676 14.3071V14.6152H16.4216V15.6936H16.8838V14.9233H17.3459V15.6936H18.5783V14.6152H18.7324V14.3071L18.4243 14.076V13.5369H17.9621V13.7294L17.5 13.3828ZM17.654 14.9233H18.1162V15.3855H17.654V14.9233Z",
    fill: "#292929"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10536_2686",
    x: 11.05,
    y: 12,
    width: 12.9,
    height: 15,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10536_2686"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10536_2686",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10536_2686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    fill: "white",
    transform: "translate(14 12)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10536_2686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.46479,
    height: 2.46479,
    fill: "white",
    transform: "translate(16.2676 13.3828)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapGridIcon);
export default __webpack_public_path__ + "static/media/map-grid-icon.136bafe8f48abe7a26297863fb7a5ed6.svg";
export { ForwardRef as ReactComponent };